/** Parse monetário pt-BR (ex.: "1.234,56", "0,00", número). Exportado para bater total da despesa com a soma na validação ao salvar. */
export function parseValorMonetarioBr(raw) {
  if (raw == null || raw === '') return 0
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  let s = String(raw)
    .trim()
    .replace(/R\$\s?/gi, '')
    .replace(/\s/g, '')
  if (!s) return 0
  if (/,/.test(s)) {
    s = s.replace(/\./g, '').replace(',', '.')
  } else {
    const parts = s.split('.')
    if (parts.length > 2) {
      s = parts.join('')
    } else if (parts.length === 2 && parts[1].length === 3) {
      s = parts[0] + parts[1]
    }
  }
  const n = Number(s)
  return Number.isFinite(n) ? n : 0
}

function isPagamentoFaturado(pag) {
  const fp = pag?.formaPagamento
  if (!fp) return false
  if (Number(fp.pag_idtipo) === 6) return true
  if (Number(fp.value) === 1) return true
  const lab = String(fp.label || '').toUpperCase()
  return lab.includes('FATURADO')
}

function hasFormaPagamentoDespesaSelecionada(pag) {
  const fp = pag?.formaPagamento
  if (!fp) return false
  const v = fp.value
  if (v === null || v === undefined || v === '') return false
  if (Number(v) === 0) return false
  const lab = String(fp.label || '')
  if (/selecione/i.test(lab)) return false
  return true
}

function pagamentoEhPagamentoDaPropriaTaxaMaquininha(pagamento, fornecedorIdLinha) {
  const linhaId = Number(fornecedorIdLinha || 0)
  const operadoraId = Number(pagamento?.formaPagamento?.pag_fornecedor_id || 0)
  return linhaId > 0 && operadoraId > 0 && linhaId === operadoraId
}

/**
 * Mesma ideia do reducer (taxa cartão). Valor numérico já parseado via parseValorMonetarioBr.
 */
function valorPagamentoDespesaComTaxa(pagamento, valorBase, fornecedorIdLinha = null) {
  const valor =
    valorBase !== undefined
      ? valorBase
      : parseValorMonetarioBr(pagamento?.valor ?? pagamento?.total)
  if (pagamentoEhPagamentoDaPropriaTaxaMaquininha(pagamento, fornecedorIdLinha)) {
    return valor
  }
  if (pagamento?.formaPagamento?.pag_credito !== 'SIM') return valor
  const parcela = pagamento?.parcela?.value ?? 1
  const taxa = parcela === 1 ? 0.05 : 0.15
  return valor + valor * taxa
}

/**
 * Total usado só na validação (salvar) e no status visual da linha: inclui FATURADO,
 * que o Redux remove de `totalPago`.
 */
export function getTotalPagoValidacaoDespesaFornecedor(row) {
  const pagamentos = row?.pagamentos || []
  const totalDespesa = parseValorMonetarioBr(row?.total)
  const linhasComForma = pagamentos.filter(hasFormaPagamentoDespesaSelecionada)
  const fornecedorIdLinha = Number(row?.fornecedor?.value || 0)

  let soma = 0
  for (const pag of pagamentos) {
    if (!hasFormaPagamentoDespesaSelecionada(pag)) continue

    let val = parseValorMonetarioBr(pag.valor)
    if (
      isPagamentoFaturado(pag) &&
      val <= 0 &&
      totalDespesa > 0 &&
      linhasComForma.length === 1
    ) {
      val = totalDespesa
    }

    soma += valorPagamentoDespesaComTaxa(pag, val, fornecedorIdLinha)
  }
  return soma
}
